module.exports = __webpack_public_path__ + "img/cycle.f248615c.svg";